
<!-- tabletravelexpense.vue -->
<template>
  <Tables :stickyHeader="true" ref="tableGrid"
        :columns= this.coluna
        :showReload="false"
        v-on:Load="onLoad"
        :showButtonNew="true"
        :newHeaderStatus="false"
        :showHeader="true"
        >
        <tr v-for="data in dataDespesasFuncionario" :key="data.id" :class="{'being-fired': data.emProcessoDemissao}">
            <TableColumn :IsText="!data.dataDemissao" :IsTextLocked="!!data.dataDemissao"  v-on:Edit="onSelect(data)" :status="1" :value="data.colaborador" />
            <TableColumn :IsText="!data.dataDemissao" :IsTextLocked="!!data.dataDemissao" v-on:Edit="onSelect(data)" :status="1" :value="data.tecnico ? data.tecnico : 'N/D'" />
            <TableColumn :IsText="!data.dataDemissao" :IsTextLocked="!!data.dataDemissao" v-on:Edit="onSelect(data)" :status="1" :value="data.coordenador !== undefined ? data.coordenador == null ? 'N/D': data.coordenador : 'N/D'" />
            <TableColumn :IsText="!data.dataDemissao" :IsTextLocked="!!data.dataDemissao" v-on:Edit="onSelect(data)" :status="1" :value="data.cargo !== null || data.cargo !== undefined ? data.cargo: 'N/D'" />
            <TableColumn :IsText="!data.dataDemissao" :IsTextLocked="!!data.dataDemissao" v-on:Edit="onSelect(data)" :status="1" :value="data.despesasViagens !== null || data.obra !== undefined ? data.obra == null ? 'N/D': data.obra : 'N/D'" />
            <!-- <TableColumn :IsTextYellow="data.statusDespesa != 2"   :IsTextGreen="data.statusDespesa == 2"   v-if="hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL)" v-on:Edit="onSelect(data)" :status="1" :value="data.statusDespesa !== null ? data.statusDespesa == 2 ? 'AG. APROVAÇÃO TRANSPORTE' : 'AG. APROVAÇÃO COORDENADOR' : 'N/D'" /> -->
            <!-- <TableColumn :IsTextYellow="data.statusDespesa != 2" :IsTextGreen="data.statusDespesa == 2" v-on:Edit="onSelect(data)" :status="1" :value="data.statusDespesa !== null ? data.statusDespesa == 2 ? 'AG. APROVAÇÃO TRANSPORTE' : 'AG. APROVAÇÃO COORDENADOR' : 'N/D'" /> -->
            <TableColumn :IsTextOrange="data.statusDespesa == 9" :IsTextYellow="data.statusDespesa == 1" :IsTextGreen="data.statusDespesa == 2" :IsTextBlue="data.statusDespesa == 3"  v-on:Edit="onSelect(data)" :status="1" :value="data.statusDespesa !== null ? data.statusDespesa == 9 ? 'AG. APROVAÇÃO TÉCNICO' : data.statusDespesa == 2 ? 'AG. APROVAÇÃO TRANSPORTE' : data.statusDespesa == 3 ? 'AG. APROVAÇÃO DIRETORIA' : 'AG. APROVAÇÃO COORDENADOR' : 'N/D'"/>
            <TableColumn :IsText="!data.dataDemissao" :IsTextLocked="!!data.dataDemissao" v-on:Edit="onSelect(data)" :status="1"  v-if="hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL)" :value="data.primeiroAdiantamento !== null ? 'SIM' : 'NÃO'" />
            <TableColumn :IsText="!data.dataDemissao" :IsTextLocked="!!data.dataDemissao" v-on:Edit="onSelect(data)" :status="1" :value="data.dataViagemInicio !== null || data.dataViagemInicio !== undefined ? data.dataViagemInicio : 'N/D'" />
            <TableColumn :IsText="!data.dataDemissao" :IsTextLocked="!!data.dataDemissao" v-on:Edit="onSelect(data)" :status="1" :value="data.datafimviagem !== null || data.datafimviagem !== undefined ? data.datafimviagem : 'N/D'" />
            <TableColumn :IsText="!data.dataDemissao" :IsTextLocked="!!data.dataDemissao" v-on:Edit="onSelect(data)" :status="1" :value="data.despesasViagens !== null || data.adiantamentoDescricao !== undefined ? formatMoney(data.adiantamentoDescricao == null ? 0 : data.adiantamentoDescricao ): '0'" />
            <TableColumn :IsText="!data.dataDemissao" :IsTextLocked="!!data.dataDemissao" v-on:Edit="onSelect(data)" :status="1" :value="data.valorTotal !== null || data.valorTotal !== undefined ? formatMoney(data.valorTotal): 'N/D'" />
            <TableColumn :IsText="!data.dataDemissao" :IsTextLocked="!!data.dataDemissao" v-on:Edit="onSelect(data)" :status="1" :value="data.saldo !== null || data.saldo !== undefined ? formatMoney(data.saldo): 'N/D'" />
            <TableColumn :IsText="!data.dataDemissao" :IsTextLocked="!!data.dataDemissao" v-on:Edit="onSelect(data)" :status="1" :value="data.totalDespesa !== null || data.totalDespesa !== undefined ? data.totalDespesa : 'N/D'" />
          </tr>
         <template #header-card-actions>
          <div class="buttons-table-action mr-2" v-if="hasRole(roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL)" >
            <!-- <button class="importaexcel " ><i class="fas fa-history"></i> HISTORICO DE LOTE</button> -->
            <button class="importaexcel " @click="generatelote" ><i class="fas fa-file-excel mr-1"></i> GERAR LOTE</button>
          </div>
        </template>
    </Tables>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import TravelExpenseRepository from '@/shared/http/repositories/business/travelexpense.js'
import { loading, toast } from '@/shared/utils/UIHelper'
import localStoreHelper from '@/shared/utils/localStoreHelper'
import Tools from '@/components/tools/Tools.js'

export default {
  name: 'TableTravelExpense',
  mixins: [ActionsForm],
  data () {
    return {
      coluna: [],
      dataDespesasFuncionario: [],
      objList: [],
      datadatasviagem: '',
      dataSearch: localStoreHelper.viagem.prestacaoContas() || {},
      localEmpresa: null
    }
  },
  props: {
    prestacao: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    'prestacao' () {
      this.onLoad()
    }
  },
  mounted () {
    this.colunaVerifica()
  },
  methods: {
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    onLoad () {
      loading.push()
      this.dataSearch.CompanyID = this.CompanySelected
      this.dataSearch.TipoPerfil = 1

      if (this.hasRole(this.roles.RW_REAL_ESTA_ADMIN) || this.hasRole(this.roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL)) {
        TravelExpenseRepository.GetAllUsuarioAdmin(this.dataSearch)
          .then((Response) => {
            loading.pop()
            this.$refs.tableGrid.LoadAllByData(Response)
            let lista = Response.data.data || []
            // Transportes/Controladoria sem ser ADM: oculta funcionarios DEMITIDOS (dataDemissao preenchido),
            // EXCETO despesas em AG. APROVACAO TRANSPORTE (status 2) — precisam ser aprovadas mesmo com o
            // colaborador ja demitido. Em processo de desligamento (emProcessoDemissao=true, tarja vermelha)
            // CONTINUA aparecendo pra prestacao de contas ser finalizada antes do RH fechar.
            if (!this.hasRole(this.roles.RW_REAL_ESTA_ADMIN)) {
              lista = lista.filter((d) => !d.dataDemissao || d.statusDespesa === 2)
            }
            this.dataDespesasFuncionario = lista
            let total = 0
            this.dataDespesasFuncionario.forEach((Element, index) => {
              this.dataDespesasFuncionario[index].dataViagemInicio = this.calculaDataInicoViagem(Element)
              this.dataDespesasFuncionario[index].datafimviagem = this.calculaDataFimViagem(Element)
              this.dataDespesasFuncionario[index].totaldespesas = Element.dataRegistroDespesa
              this.dataDespesasFuncionario[index].saldo = Element.saldo
              total = total + Element.valorTotal
            })
            this.$emit('totalDespesas', total)
          })
      } else {
        TravelExpenseRepository.GetAllUsuario(this.dataSearch)
          .then((Response) => {
            loading.pop()
            this.$refs.tableGrid.LoadAllByData(Response)
            this.dataDespesasFuncionario = Response.data.data
            let total = 0
            this.dataDespesasFuncionario.forEach((Element, index) => {
              this.dataDespesasFuncionario[index].dataViagemInicio = this.calculaDataInicoViagem(Element)
              this.dataDespesasFuncionario[index].datafimviagem = this.calculaDataFimViagem(Element)
              this.dataDespesasFuncionario[index].totaldespesas = Element.dataRegistroDespesa
              this.dataDespesasFuncionario[index].saldo = Element.saldo
              total = total + Element.valorTotal
            })
            this.$emit('totalDespesas', total)
          })
      }
    },
    calculatotaldespesaviagem (despesaviagem) {
      let total = 0
      despesaviagem.forEach((Element) => {
        total += Element.valor
      })
      return total
    },
    colunaVerifica () {
      if (this.hasRole(this.roles.RW_REAL_ESTA_ADMIN) || this.hasRole(this.roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL)) {
        this.coluna = ['Nome Usuário', 'ADM', 'Coordenador', 'Função', 'Obra', 'Situação', 'Primeiro Adiantamento', 'Início da viagem', 'Fim da viagem', 'Valor do adiantamento', 'Gasto', 'Saldo', 'Total de despesas']
      } else {
        this.coluna = ['Nome Usuário', 'ADM', 'Coordenador', 'Função', 'Obra', 'Situação', 'Início da viagem', 'Fim da viagem', 'Valor do adiantamento', 'Gasto', 'Saldo', 'Total de despesas']
      }
    },
    onSelect (data) {
      TravelExpenseRepository.GetUsuarioGrupoDespesaViagem()
        .then((Response) => {
          const coordenadorId = Response.data.data.coordenadorId
          const tecnicoId = Response.data.data.tecnicoId
          const semGrupoCoordTec = coordenadorId === null && tecnicoId === null
          const isTransporteOuAdmin = this.hasRole(this.roles.RW_REAL_ESTA_ADMIN) || this.hasRole(this.roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL)

          if (semGrupoCoordTec && data.statusDespesa !== 3) {
            this.$router.push(`/despesa/viagem/funcionario?funcionario=${data.funcionarioId}`)
          } else if ((coordenadorId !== null || tecnicoId !== null) && data.statusDespesa === 1) {
            this.$router.push(`/despesa/viagem/funcionario?funcionario=${data.funcionarioId}`)
          } else if (tecnicoId !== null && data.statusDespesa === 9) {
            this.$router.push(`/despesa/viagem/funcionario?funcionario=${data.funcionarioId}`)
          } else if (data.statusDespesa === 3 && isTransporteOuAdmin) {
            // Permite Transportes/Controladoria/Admin abrir o detalhe quando status==DIRETORIA
            // para usar o botão REVISAR (retorno pra Controladoria/Transportes)
            this.$router.push(`/despesa/viagem/funcionario?funcionario=${data.funcionarioId}`)
          }
        })
    },
    generatelote () {
      loading.push()
      TravelExpenseRepository.GenerateLote(this.CompanySelected)
        .then((Response) => {
          this.onLoad()
          loading.pop()
          this.onDownloadExcel(Response)
        })
        .catch((Error) => {
          loading.pop()
          toast.error('Não foi possivel gerar o lote')
        })
    },
    calcularSaldo (despesaviagem, saldo) {
      let total = this.calculatotaldespesaviagem(despesaviagem)
      return saldo - total
    },
    onDownloadExcel (response) {
      const obj = response.data.data
      const contentType = obj.contentType
      const data = Uint8Array.from(atob(obj.file), c => c.charCodeAt(0))
      var a = window.document.createElement('a')
      a.href = window.URL.createObjectURL(new Blob([data], { type: contentType }))
      a.download = obj.name
      document.body.appendChild(a)
      a.click()
      // toast.success('Arquivo gerado com sucesso!')
      // loading.close()
      this.objList.forEach(element => {
        element.checked = false
      })
    },
    calculaDataInicoViagem (despesasviagem) {
      let dataRegistro = despesasviagem.inicio
      var dataFormatada = dataRegistro.replace(/-/g, '/').split('T')[0]
      var partes = dataFormatada.split('/')
      // Formatar a data no formato brasileiro
      var dataFormatadas = partes[2] + '/' + partes[1] + '/' + partes[0]

      return dataFormatadas
    },
    calculaDataFimViagem (despesasviagem) {
      let dataRegistro = despesasviagem.fim
      var dataFormatada = dataRegistro.replace(/-/g, '/').split('T')[0]
      var partes = dataFormatada.split('/')
      // Formatar a data no formato brasileiro
      var dataFormatadas = partes[2] + '/' + partes[1] + '/' + partes[0]

      return dataFormatadas
    }
  }
}
</script>

<style scoped>
.buttons-table-action{
  display: flex;
  justify-content: right;
  align-items: center;
}
.importaexcel:hover {
  background: #008144 !important
}
.importaexcel{
  width: 100% !important;
  height: 2rem !important;
  border-radius: 10px;
  font-size: 12px;
  font-weight: bold;
  color: white !important;
  background: #008144 !important;
  padding: 0 1rem !important;
}
/* Tarjas da grid (ZPG-15, tons pedidos em 2026-09-25): desligamento vermelho claro, encerramento de
   Diversos amarelo claro. Fundo claro pede texto escuro. */
tr.being-fired {
   background-color: #ff7081;
}
tr.being-fired >>> a {
   color: #212529;
   font-weight: bold;
}
tr.being-fired:hover >>> a {
   color: #7a0d1c;
   font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/travelexpensezpag/components/Tabs/tabletravelexpense/tabletravelexpense.vue